var map = {
	"./AE.png": [
		1630,
		1630
	],
	"./BH.png": [
		2298,
		2298
	],
	"./DJ.png": [
		1310,
		1310
	],
	"./DZ.png": [
		3822,
		3822
	],
	"./EG.png": [
		8848,
		8848
	],
	"./EU.png": [
		4786,
		4786
	],
	"./GB.png": [
		507,
		507
	],
	"./IL.png": [
		455,
		455
	],
	"./IQ.png": [
		8610,
		8610
	],
	"./JO.png": [
		5709,
		5709
	],
	"./KS.png": [
		7550,
		7550
	],
	"./KW.png": [
		1658,
		1658
	],
	"./LB.png": [
		1742,
		1742
	],
	"./MA.png": [
		1646,
		1646
	],
	"./OM.png": [
		7188,
		7188
	],
	"./QA.png": [
		5354,
		5354
	],
	"./RS.png": [
		2825,
		2825
	],
	"./SA.png": [
		5364,
		5364
	],
	"./SD.png": [
		9865,
		9865
	],
	"./SO.png": [
		1802,
		1802
	],
	"./SY.png": [
		6076,
		6076
	],
	"./TN.png": [
		6186,
		6186
	],
	"./US.png": [
		2484,
		2484
	],
	"./YE.png": [
		6406,
		6406
	],
	"./ara.png": [
		2956,
		2956
	],
	"./bil.png": [
		119,
		119
	],
	"./eng.png": [
		762,
		762
	],
	"./saudi.png": [
		7310,
		7310
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6931;
module.exports = webpackAsyncContext;